import React from 'react';
import { formatDwell, isOverDwell } from '../utils';

const DwellCell = ({ getValue }) => {
    const days = getValue();
    return (
        <span className={`text-sm ${isOverDwell(days) ? 'font-semibold text-destructive' : ''}`}>
            {formatDwell(days)}
        </span>
    );
};

export default DwellCell;
